import { call, put, select, takeLatest } from "redux-saga/effects";
import iq_api_v2 from "../../../../services/iqApiV2";
import { FETCH_SPOT_CONTACTS_REQUEST, FetchSpotContactsFailure, FetchSpotContactsSuccess } from "../../actions/targetedReachout/spotContactsActions";




async function spotContacts(clientName, accountName, userId, type = 'spot') {

try {
  const response = await iq_api_v2.post('/contact/list_contacts', null, {
    params: {
      user_id: userId,
      client: clientName,
      account: accountName,
    },
  });
  return response?.data?.result;
} catch (error) {
  console.error('Error:', error.response ? error.response.data : error.message);
}

  }

// Worker Saga
function* fetchSpotContactsSaga() {
  try {
    const payload = yield select(
      (state) => state?.spotContactsReducer?.payload
    );
    const {  clientName,accountName,userId,type } = payload;
    const data = yield call(
        spotContacts,
        clientName,accountName,userId,type
    );
    yield put(FetchSpotContactsSuccess(data));
  } catch (error) {
    yield put(FetchSpotContactsFailure(error.message));
  }
}

// Watcher Saga
export function* watchSpotContactsSaga() {
  yield takeLatest(FETCH_SPOT_CONTACTS_REQUEST, fetchSpotContactsSaga);

}
